import { useEffect } from 'react'
import '../../App.css'
import { useAppDispatch } from '../../app/hooks'
import { Page } from '../../Page'
import { resetButtons, setBackButtonVisible, setHomeButtonVisible } from '../menu/menuSlice'
import styles from './dataDelete.module.css'

export function Merchandise() {
  const dispatch = useAppDispatch()

	useEffect(() => {
    dispatch(resetButtons())
    dispatch(setBackButtonVisible(true))
    dispatch(setHomeButtonVisible(true))
    
  }, [dispatch])
    return(
        <Page>
          <div className={styles.content}>
        <h1>PartyPlanner</h1>
         <br></br>
          <h2>Merchandise</h2>
          <br></br>
          <div>PartyPlanner Merchandise coming soon...</div>
          </div>
        </Page>
    )
}